import { combineReducers } from "redux";

import faq from "../features/admin/faqs/faq/Slice";

import faqcategory from "../features/admin/faqs/faqcategory/Slice";

import common from "../features/admin/common/Slice";

const faqs = combineReducers({
    faq,
    faqcategory,
    common
});

export default faqs;